// After a republish, detect the new build and reload the installed app when it's safe to do so.
const CHECK_EVERY_MS = 5 * 60 * 1000;
const RETRY_SAFE_MS = 20 * 1000;

const scriptHash = (html) => (html.match(/\/static\/js\/main\.([0-9a-f]{8,})\.js/) || [])[1] || null;
const currentHash = () => {
    const s = [...document.scripts].map((x) => x.src).find((src) => /\/static\/js\/main\.[0-9a-f]{8,}\.js/.test(src));
    return s ? scriptHash(s) : null;
};

// Safe = nobody is typing in a field or working in an open dialog.
const isSafe = () => {
    const el = document.activeElement;
    const typing = el && (el.tagName === "TEXTAREA" || (el.tagName === "INPUT" && !["button", "checkbox", "radio", "submit"].includes(el.type)) || el.isContentEditable);
    const dialog = document.querySelector('[role="dialog"], [role="alertdialog"]');
    return !typing && !dialog;
};

const showBanner = () => {
    const b = document.createElement("div");
    b.setAttribute("data-testid", "app-updating-banner");
    b.textContent = "Updating to the latest version…";
    Object.assign(b.style, {
        position: "fixed", top: "16px", left: "50%", transform: "translateX(-50%)", zIndex: 99999, background: "#0F1A2E",
        color: "#fff", padding: "10px 18px", borderRadius: "999px", font: "600 13px system-ui, sans-serif", boxShadow: "0 8px 24px rgba(0,0,0,.25)",
    });
    document.body.appendChild(b);
};

let pending = false;
const reloadWhenSafe = () => {
    if (!isSafe()) return setTimeout(reloadWhenSafe, RETRY_SAFE_MS);
    showBanner();
    setTimeout(() => window.location.reload(), 1200);
};

async function check() {
    const mine = currentHash();
    if (!mine || pending) return;
    try {
        navigator.serviceWorker?.getRegistration().then((r) => r && r.update()).catch(() => {});
        const res = await fetch(`/?v=${Date.now()}`, { cache: "no-store", credentials: "same-origin" });
        if (!res.ok) return;
        const latest = scriptHash(await res.text());
        if (latest && latest !== mine) {
            pending = true;
            reloadWhenSafe();
        }
    } catch (_) { /* offline — try again later */ }
}

export function startAutoUpdate() {
    setTimeout(check, 15000);
    setInterval(check, CHECK_EVERY_MS);
    document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") check(); });
    window.addEventListener("online", check);
}
